// extracted by mini-css-extract-plugin
module.exports = {"table":"styles__table___qudbO","submitButton":"styles__submitButton___bIsr9","commentForm":"styles__commentForm___1AMOh"};